import { doc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";

export const readAllMessages = async (ticketId: string): Promise<void> => {
  const collectionRef = doc(db, `customerSupportTickets/${ticketId}`);
  await updateDoc(collectionRef, {
    adminUnreadMessagesCount: 0,
  });
};
